export default __webpack_public_path__ + "static/media/logo.0aa40113.svg";